import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'jhi-messages',
  template: '<div [id]="id"  class="alert alert-danger alert-secondary" [attr.aria-hidden]="!isInvalid"><ng-content></ng-content></div>',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent {

    @HostBinding('class.show-messages')
    isInvalid = false;

    @Input()
    id: string;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/messages/messages.component.ts